export const POWERBI_REPORTS_TITLE = 'Power BI Reports';
export const POWERBI_REPORTS_PATH = '/power-bi-reports';

export { default } from './PowerBIReports';
